import script from "./DescriptionHistoryFetcher.vue?vue&type=script&lang=js"
export * from "./DescriptionHistoryFetcher.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__